const availableShirtSizes = [
    {
        size: 'PP',
        code: 'XS'
    },
    {
        size: 'P',
        code: 'S'
    },
    {
        size: 'M',
        code: 'M'
    },
    {
        size: 'G',
        code: 'L'
    },
    {
        size: 'GG',
        code: 'XL'
    }
]

export default availableShirtSizes
